import React, { Component } from 'react'

import ContentInfo from '../_ContentInfo'
import Display from '../../../../../v2SPRINTA/atoms/Display'
import { FormGroup, Textarea, Select } from '../../../../../v2SPRINTA/atoms/Form'
import { Col, Row } from '../../../../../v2SPRINTA/atoms/Grid'

import SprintaTips from '../../../../../SPRINTA/molecules/SprintaTips'

import { saveExperience } from '../../_utils'

class HowWillItBe extends Component {

    handleChange(target) {
        let experience = this.props.data.experience
        experience[target.name] = target.value
        
        this.props.setData({
            experience
        }, () => {
            if(['radio', 'select-one', 'checkbox'].indexOf(target.type) > -1)
            this.handleChanged(target)
        })
    }
    
    handleChanged(target) {
        this.validAndSaveField(target)
    }

    validAndSaveField(target) {
        const { name } = target

        const form = {}
        form[name] = this.props.data.experience[name]
        let async = saveExperience(this.props.token, form)
        .then(resp => {})

        if(this.props.async) this.props.async(async)
    }

    hasFieldError = {
        description: () => {
            if(!this.props.data.experience.description) {
                let error = "Informe uma descrição"
                this.description.setError(error)

                return {
                    element: this.description.refs.textarea,
                    error
                }
            }
            return false
        },
        // intensity: () => {
        //     if(!this.props.data.experience.intensity) {
        //         let error = "Informe a intensidade"
        //         // this.description.setError(error)
        //         return {
        //             element: this.intensity.refs.div,
        //             error
        //         }
        //     }
        //     return false
        // },
        // minAge: () => {
        //     if(!this.props.data.experience.minAge) {
        //         let error = "Informe a idade mínima"
        //         this.minAge.setError(error)
        //         return {
        //             element: this.minAge.refs.select,
        //             error
        //         }
        //     }
        //     return false
        // },
    }

    inStep() {
        let { description, intensity, minAge, duration, placeType, doWhat } = this.props.data.experience
        return description || intensity || minAge || duration || placeType || doWhat ? true  : false
    }

    validate() {
        let errors = []

        Object.keys(this.hasFieldError).forEach(item => {
            let error = this.hasFieldError[item]();
            if(error)
            errors.push(error)
        })

        return errors
    }

    render() {
        let data = this.props.data
        return (
            <ContentInfo
                title='Descreva as suas atividades e aulas'
                description='Descreva um pouco das atividades para nós, informe detalhes fundamentais para que os usuários decidam se irão participar ou não.'
                steps={this.props.steps}>
                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Detalhe as atividades que sua academia fornece
                            </Display>
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup>
                            <SprintaTips>
                                A descrição da sua academia é uma oportunidade de inspirar os usuários a escolher sua academia. Especifique o que e quais atividades o pessoal poderá fazer na sua academia, procure oferecer algo especial, marcante.. algum diferencial exclusivo da sua academia.
                            </SprintaTips>
                        </FormGroup>
                    </Col>

                    <Col size='12'>
                        <FormGroup>
                            <Textarea
                                label='Descreva aqui o seu espaço, atividades e aulas que sua academia possui.'
                                maxLength={600}
                                ref={ref => this.description = ref}
                                name="description"
                                maxLengthString="Você digitou {lenght} de {limit} caracteres"
                                value={data.experience.description || ''}
                                onChange={e => this.handleChange(e.target)}
                                onChangeDOM={e => this.handleChanged(e.target)}
                                />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col size='12'>
                        <FormGroup>
                            <Display size={3}>
                                Qual a idade mínima para frequentar sua academia?
                            </Display>
                        </FormGroup>
                    </Col>
                    <Col size='12 12 6'>
                        <FormGroup>
                            <Select
                                name='minAge'
                                onChange={e => this.handleChange(e.target)}
                                label="Idade mínima"
                                ref={ref => this.minAge = ref}
                                value={data.experience.minAge || ''}
                            >
                                <option value="">Sem idade minima</option>
                                <option value="16">16 anos</option>
                                <option value="18">18 anos</option>
                                <option value="25">25 anos</option>
                            </Select>
                        </FormGroup>
                    </Col>
                </Row>
            </ContentInfo>
        )
    }

}

export default HowWillItBe


// WEBPACK FOOTER //
// ./src/App/pages/CreateGym/Steps/HowWillItBe/index.js